<script setup lang="ts">
import PrivacyTitle from '~/components/privacyPolicy/privacyTitle/PrivacyTitle.vue';
import PrivacyDescription from '~/components/privacyPolicy/privacyDescription/PrivacyDescription.vue';
import PrivacyContent from '~/components/privacyPolicy/privacyContent/PrivacyContent.vue';
import {privacyPolicyData} from '~/constants/privacyPolicy/privacyPolicyData';

useSeoMeta({
    title: 'Privacy Policy | The4People',
    description: 'Privacy Policy of The4People.',
});

definePageMeta({
    layout: 'default',
});
</script>

<template>
    <div class="privacy">
        <PrivacyTitle :title="privacyPolicyData.title" />
        <PrivacyDescription :descriptions="privacyPolicyData.descriptions" />
        <PrivacyContent :content="privacyPolicyData.content" />
    </div>
</template>

<style lang="scss">
    @import "assets/styles/scss/components/privacy-policy";
</style>
